import React from "react";
//#region redux
import { useSelector, useDispatch } from "react-redux";
import { AppState } from "store";
import { ThunkDispatch } from "redux-thunk";
import { closeDialog, displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { WidgetBaseProps } from "models/propTypes/commonPropTypes";
import { TranslationKeys } from "translations";
import { FAQConstants } from "utils/constants";
import { LocalizationHelperInstance } from "utils/helpers";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { StyledButton } from "components/common";
import {
  useSupportTicketCreateDialog,
  useSupportTicketCreateDialogWithFAQ,
  useOldSupporDialogHelper,
} from "components/support";
//#endregion
import { useSupportTeamContent } from "serviceHooks/useSupportTeamContent";
import cssExports from "theme/styles/main.module.scss";
import wHeadset from "images/w-headset@2x.png";

const Support: React.FC<WidgetBaseProps> = (props) => {
  const companyId = useSelector((state: AppState) => state.auth.selectedCompany.id);
  const { data, loading } = useSupportTeamContent(companyId);
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();

  const hasTeam = data?.team && data.team.members.length > 0;
  const isExternal = !!data?.externalAgencyId;

  React.useEffect(() => {
    // Hide while loading (wait for response) and when the SupportTeamWidget is showing
    props.onVisibilityChange?.(loading || !!hasTeam || isExternal);
  }, [loading, hasTeam, isExternal, props.onVisibilityChange]);

  const { hasOldSupportDialog } = useOldSupporDialogHelper();

  const onFAQButtonClick = () => {
    window.open(FAQConstants.FAQUrl, "_blank");
  };

  const { getDialog: getSupportTicketCreateDialog } = useSupportTicketCreateDialog();
  const supportTicketDialogWithFAQ = useSupportTicketCreateDialogWithFAQ(undefined, () => dispatch(closeDialog()));

  const onSupportButtonClick = () => {
    if (hasOldSupportDialog) {
      dispatch(displayDialog(getSupportTicketCreateDialog()));
    } else {
      dispatch(displayDialog(supportTicketDialogWithFAQ));
    }
  };

  return (
    <Grid item container className={cssExports.supportWidgetContainer} columnGap={2} direction="row">
      <Grid item>
        <img src={wHeadset} className={cssExports.supportImage} />
      </Grid>
      <Grid item xs sm className={cssExports.supportText} container>
        <Grid item container spacing={1} direction="column">
          <Grid item className={cssExports.supportHeaderText}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.HelpTitle)}
          </Grid>
          <Grid item className={cssExports.supportDescription}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.HelpDescription)}
          </Grid>
          <Grid item>
            <Grid item container spacing={1} direction="row">
              <Grid item>
                <StyledButton className={cssExports.btnXSmall} onClick={onFAQButtonClick}>
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Faq)}
                </StyledButton>
              </Grid>
              <Grid item>
                <StyledButton className={cssExports.btnXSmall} secondary onClick={onSupportButtonClick}>
                  {LocalizationHelperInstance.getFormattedMessage(
                    TranslationKeys.SupportIssue.FAQSupportFlowAskAQuestion
                  )}
                </StyledButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Support;
